import { render, staticRenderFns } from "./ApplicationTemplate.vue?vue&type=template&id=3c093b10&scoped=true"
import script from "./ApplicationTemplate.vue?vue&type=script&lang=js"
export * from "./ApplicationTemplate.vue?vue&type=script&lang=js"
import style0 from "./ApplicationTemplate.vue?vue&type=style&index=0&id=3c093b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c093b10",
  null
  
)

export default component.exports